import { render, staticRenderFns } from "./checkout-terms.vue?vue&type=template&id=3b159af3"
import script from "./checkout-terms.vue?vue&type=script&lang=js"
export * from "./checkout-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports